import { router } from '@/routes'

export const changeUrlUuid = (chatId: string) => {
    // Get the current URL
    const url = new URL(window.location.href)

    // Split the pathname into its parts
    const pathParts = url.pathname.split('/').filter(Boolean) // Filter to remove empty parts

    // Check if the last segment is a UUID
    if (pathParts.length > 0 && isValidUuid(pathParts[pathParts.length - 1])) {
        // Last part is a UUID, replace it with the new chatId
        pathParts[pathParts.length - 1] = chatId
    } else if (pathParts.length > 1) {
        // Last part is not a UUID, remove it and append the new chatId
        pathParts[pathParts.length - 1] = chatId
    } else {
        // Path is missing, append the new chatId
        pathParts.push(chatId)
    }

    // Ensure only the last segment is the chatId
    if (pathParts.length > 1 && isValidUuid(pathParts[pathParts.length - 2])) {
        pathParts.splice(pathParts.length - 2, 1)
    }

    // Join the parts back to form the new pathname
    const newPathname = `/${pathParts.join('/')}`
    // Update the URL without reloading the page
    void router.navigate({ to: `${newPathname}${url.search}`, replace: true })
}

export const isValidUuid = (uuid: string) => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
    return uuidRegex.test(uuid)
}
